// extracted by mini-css-extract-plugin
export var active = "_1t-7";
export var container = "_1t-0";
export var evenWidth = "_1t-4";
export var large = "_1t-5";
export var outlet = "_1t-8";
export var slide = "_1t-2";
export var small = "_1t-6";
export var tab = "_1t-3";
export var tabs = "_1t-1";